'use client';

import dynamic from 'next/dynamic';
import LazyLoad from 'react-lazyload';
interface Props {
  socialMedias: any;
}
const LivingHisea = dynamic(() => import('./livingHisea'), { ssr: false });

const LivingHiseaLazyLoad = (props: Props) => {
  const { socialMedias } = props;
  return (
    <LazyLoad
      offset={300}
      once
      placeholder={<div className='min-h-[964px] lg_min-h-[793px]' />}
    >
      <LivingHisea socialMedias={socialMedias} />
    </LazyLoad>
  );
};

export default LivingHiseaLazyLoad;
